import { render, staticRenderFns } from "./BatchPaymentsData.vue?vue&type=template&id=6a5216ae"
import script from "./BatchPaymentsData.vue?vue&type=script&lang=js"
export * from "./BatchPaymentsData.vue?vue&type=script&lang=js"
import style0 from "./BatchPaymentsData.vue?vue&type=style&index=0&id=6a5216ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports